import {
    CREATE_SETTINGS,
} from "../actions";

const settings = (state = [], action) => {
    switch (action.type) {
    case CREATE_SETTINGS:
        return action
    default:
        return state
    }
}

export default settings;
